/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>httpTracker.service.ts</name>
///
/// <description>
///  Logs HTTP requests
///  Extends HTTP object  
///  
/// </description>
///
/// <author>Scott Grau</author>
/// <created>30 Sept 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 15Sep30 SG  1.0.0000         First cut 
/// 12Dec16  SG  1.0.0000        Adding Calls to Log API; 
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Http,  Request, Response, ConnectionBackend, RequestOptions, RequestOptionsArgs, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {LogService} from "./log.service";
import {Injectable, Injector} from '@angular/core';
import {HydUser} from "../models/user";
import { LogEntry, Severity } from './Crestron.HydrogenAPI.LogApi.service'
import { Message } from 'primeng/primeng';
import { MediatorService } from './mediator.service';
import { MediatorEventLookup } from './mediator-event-lookup.service';

@Injectable()
export class HttpTracker extends Http {
    private logService: LogService;
    private _mediator: MediatorService;
    private logEntry : LogEntry;
    injector: Injector;   
     
  constructor
  (
    backend: ConnectionBackend, 
    defaultOptions: RequestOptions, 
    injector: Injector,
    private _hydUser: HydUser
  ) 
  {
    
    super(backend, defaultOptions);
    this.injector = injector;
  }
  //YH 11/16/2016 Task 9133:Turn on Security for All Portal Components
  request(url: string , options?: RequestOptionsArgs): Observable<Response> {    
    
    if (options) {      
      this.CreateAuthorizationHeader(options.headers);
    }
    else {
      let headers = new Headers();
      this.CreateAuthorizationHeader(headers);
      options = {headers:headers};
    }

    try {
          if (this.logService == null) {
              this.logService = this.injector.get(LogService);
          }    

          if (this._mediator == null) {
              this._mediator = this.injector.get(MediatorService);
          } 

          //Do not log if making a log entry; Prevents stack overflow
          if (typeof url == "string" && !url.includes("CreateLogEntry")) { 
            this.logEntry = new LogEntry()
            this.logEntry.message = 'HTTP request : ' + options.method + ' ' + url + ' body : ' + options.body;
            this.logEntry.severity = Severity.Trace;
            this.logService.logLogEntry(this.logEntry);
          }
    }
    catch(exception)
    {
        console.log("Could not write message to log service. Error:" + exception.message);
    }

    //YH 1/19/2017 Fix for Firefox. Spell out to pesky FF that it should accept a json
    options.headers.append('Accept', 'application/json');

    return super.request(url, options).catch((error: Response) => {
        if ((error.status !== <number>204 || error.status !== <number>200)) {
            let summary = "There was an error processing the request";
            //YH 4/5/2017
            let correlationId : string = this.correlationIdFromResponse(error);
            let payload: Message = {
                summary: summary,
                detail: correlationId != null ? correlationId : '',
                severity: "error"
            };
            this._mediator.Action(MediatorEventLookup.HttpErrorEvent, payload);
        }
        return Observable.throw(error);
    });
  }  

  //YH 11/16/2016 Task 9133:Turn on Security for All Portal Components
  CreateAuthorizationHeader(headers:Headers) {
    if (this._hydUser && this._hydUser.AccessToken)
      headers.append('Authorization', this._hydUser.AccessToken); 
  }

  //YH 4/5/2017
  private correlationIdFromResponse(res:Response) {
    try {
      return res.json().CorrelationId;
    }
    catch(err) {}
    return "";
  }
}




// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/http-tracker.service.ts